export const EXPORT_SELECTED = 'EXPORT_SELECTED';
export const EXPORT_ALL = 'EXPORT_ALL';

export const CHOOSE_EXPORT_DIALOGUE = 'CHOOSE_EXPORT_DIALOGUE';
export const EXPORT_IN_PROGRESS_DIALOGUE = 'EXPORT_IN_PROGRESS_DIALOGUE';
